import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=21d4fc0e&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=21d4fc0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4fc0e",
  null
  
)

export default component.exports